import React from 'react'
import PropTypes from 'prop-types'
import { Box, Card, CardContent, Typography, Grid } from '../../../../../components/mui/Core/index'
import { HOLD_ALLOCATION_BUCKETS, BUCKET_LABELS, BUCKET_COLORS } from '../../../../../constants/hold-allocation-constants'

const BUCKET_KEYS = [
  { key: HOLD_ALLOCATION_BUCKETS.ALL, countKey: 'allOrders' },
  { key: HOLD_ALLOCATION_BUCKETS.RELEASABLE, countKey: 'releasableOrders' },
  { key: HOLD_ALLOCATION_BUCKETS.READY_TO_ALLOCATE, countKey: 'readyToAllocateOrders' },
  { key: HOLD_ALLOCATION_BUCKETS.LOCKED, countKey: 'lockedOrders' },
]

function DashboardBuckets({ dashboard, selectedBucket, onBucketClick }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {BUCKET_KEYS.map(({ key, countKey }) => {
        const isSelected = selectedBucket === key
        const color = BUCKET_COLORS[key]
        const count = dashboard ? dashboard[countKey] : '-'
        return (
          <Grid key={key} size={{ xs: 6, sm: 3 }}>
            <Card
              onClick={() => onBucketClick(key)}
              sx={{
                cursor: 'pointer',
                border: isSelected ? `2px solid ${color}` : '2px solid transparent',
                borderRadius: 2,
                transition: 'all 0.15s ease',
                boxShadow: isSelected ? `0 2px 12px ${color}44` : '0 1px 4px rgba(0,0,0,0.08)',
                '&:hover': {
                  boxShadow: `0 2px 12px ${color}44`,
                  borderColor: color,
                },
              }}
            >
              <CardContent sx={{ pb: '12px !important', pt: 2 }}>
                <Typography
                  sx={{
                    fontSize: '0.78rem',
                    fontFamily: 'AtlasGroteskRegular',
                    color: '#606060',
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    mb: 0.5,
                  }}
                >
                  {BUCKET_LABELS[key]}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '2rem',
                    fontFamily: 'SanomatMedium',
                    color,
                    lineHeight: 1.1,
                  }}
                >
                  {count}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}

DashboardBuckets.propTypes = {
  dashboard: PropTypes.shape({
    allOrders: PropTypes.number,
    releasableOrders: PropTypes.number,
    readyToAllocateOrders: PropTypes.number,
    lockedOrders: PropTypes.number,
  }),
  selectedBucket: PropTypes.string.isRequired,
  onBucketClick: PropTypes.func.isRequired,
}

export default DashboardBuckets
